export enum View {
	Home = "Home",
	Editor = "Editor",
	Login = "Login",
	Projects = "Projects",
	Classroom = "Classroom",
	ClassroomDetail = "ClassroomDetail",
	ClassroomAssignment = "ClassroomAssignment",
	ClassroomJoin = "ClassroomJoin"
}